import {
  GetPrayerStreamErrorResponseDtoStatus,
  GetPrayerStreamSuccessResponseDtoStatus,
  ResponseMetadataMessageDtoLevel,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { assert, UnreachableCaseError } from 'ts-essentials';
import { call, put, takeLeading } from 'typed-redux-saga';
import { PrayerStreamApiService } from '../../../services/prayer-stream';
import { getAccessTokenSaga } from '../../auth/accessToken.saga';
import { streamSlice } from '../../stream/stream.slice';
import { getContainer } from '../../utils.saga';
import { getCommunityGroupListSlice } from './get-community-group-list.slice';

export function* getCommunityGroupListSaga(): Generator {
  const container = yield* getContainer();
  const { prayerStreamApi } = container.get(PrayerStreamApiService);

  yield* put(getCommunityGroupListSlice.actions.getCommunityGroupListStarted());

  const accessToken = yield* getAccessTokenSaga();
  assert(accessToken);

  // TODO: Create wrapper function to handle Axios errors.
  const { data } = yield* call(async () => {
    try {
      return await prayerStreamApi.prayerStreamControllerGetAllCommunityGroupsV1(
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
    } catch (error) {
      return {
        data: {
          metadata: {
            messages: [
              {
                level: ResponseMetadataMessageDtoLevel.ERROR,
                text: `PrayerStream level error: ${(error as Error).message}`,
              },
            ],
            requestId: '001',
          },
          status: GetPrayerStreamErrorResponseDtoStatus.OTHER,
        },
      };
    }
  });

  const { status } = data;

  switch (status) {
    case GetPrayerStreamErrorResponseDtoStatus.OTHER:
      yield* put(
        getCommunityGroupListSlice.actions.getCommunityGroupListFailed(status),
      );
      break;
    case GetPrayerStreamSuccessResponseDtoStatus.SUCCESS: {
      yield* put(
        getCommunityGroupListSlice.actions.getCommunityGroupListSucceeded(
          status,
        ),
      );

      const { payload } = data;
      yield* put(streamSlice.actions.setCommunityGroupList(payload));
      break;
    }

    /* v8 ignore next 2 */
    default:
      throw new UnreachableCaseError(status);
  }
}
export function* watchGetCommunityGroupListSaga(): Generator {
  yield* takeLeading(
    getCommunityGroupListSlice.actions.getCommunityGroupListRequested,
    function* lambda(action) {
      yield* call(getCommunityGroupListSaga, action.payload);
    },
  );
}
